import { proxyBE } from "./common";

export const revisionService = {
  listQuizOpenAll(isRevisioned, idUser) {
    return proxyBE.get(`admin/quizreview/listAll/${isRevisioned}/${idUser}`);
  },

  getQuizReview(payload) {
    return proxyBE.get(`admin/quizreview/${JSON.stringify(payload)}`);
  },

  updateQuizReview(payload) {
    return proxyBE.put(`admin/quizreview`, payload);
  },

  updateQuizReviewFeedback(payload) {
    return proxyBE.put(`admin/quizreview-feedback`, payload);
  },

  listAllConfirmedExamByRevisorId(context) {
    return proxyBE.get(`admin/examreview/listConfimedExamByRevisorId/${context}`);
  },

  listAllRevisionedExamByRevisorId(context) {
    return proxyBE.get(`admin/examreview/listAllRevisionedExamByRevisorId/${context}`);
  },

  listAllRevisionPendingExamByRevisorId(context) {
    return proxyBE.get(`admin/examreview/listAllRevisionPendingExamByRevisorId/${context}`);
  },

  listAllRevisionedPendingExam(context) {
    return proxyBE.get(`admin/examreview/listAllRevisionedPendingExam/${context}`);
  },

  insertExamReview30Cfu(payload) {
    return proxyBE.post(`admin/examreview/insertExamReview30Cfu`, payload);
  },

  updateExamReview30Cfu(payload) {
    return proxyBE.post(`admin/examreview/updateExamReview30Cfu`, payload);
  },

  listAllLessonActivity(payload) {
    return proxyBE.get(`admin/lesson-activity-review/listAll/${JSON.stringify(payload)}`);
  },

  getLessonActivity(id) {
    return proxyBE.get(`admin/lesson-activity-review/${id}`);
  },

  updateLessonActivity(payload) {
    return proxyBE.put("admin/lesson-activity-review/", payload);
  },

  updateLessonActivitySecurity(payload) {
    return proxyBE.put("admin/lesson-activity-review/security", payload);
  },

  listAllLessonActivityCompany(payload) {
    return proxyBE.get(`admin/lesson-activity-company-review/listAll/${JSON.stringify(payload)}`);
  },

  listAllSecurityCertificatesCompany(payload) {
    return proxyBE.get(`admin/lesson-activity-company-review/security-certificates/${JSON.stringify(payload)}`);
  },

  listAllSecurityCertificates(payload) {
    return proxyBE.get(`/admin/lesson-activity-review/security-certificates/${JSON.stringify(payload)}`);
  },

  getLessonActivityCompany(id) {
    return proxyBE.get(`/admin/lesson-activity-company-review/${id}`);
  },

  updateLessonActivityCompany(payload) {
    return proxyBE.put("/admin/lesson-activity-review-company/", payload);
  },
};
